<template>

	<v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" persistent>
		<v-card>
		
			<v-form ref="form" @submit.prevent="agree">
				<v-text-field
					class="px-5 pt-6"
					:label="title"
					v-model="name"
					:rules="agile.fieldRules.nameRules"
					outlined
					dense
					autofocus
					validate-on-blur
				></v-text-field>
			</v-form>
			
			<v-select
				class="mx-5"
				:items="contentTypes"
				v-model="contentType"
				item-text="name"
				item-value="id"
				label="Content type"
				required
				outlined
				dense
			></v-select>

			<v-card-actions class="pt-0">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" text @click.native="agree">Create</v-btn>
				<v-btn color="primary darken-1" text @click.native="cancel">Cancel</v-btn>
			</v-card-actions>

		</v-card>
	</v-dialog>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import fb from '@/shift/fb';
import agile from "@/shift/agile";


export default
{
	data: () =>
	({
		dialog: false,
		resolve: null,
		reject: null,
		name: '',
		contentType: null,
		title: '',
		options:
		{
			color: 'primary',
			width: 320,
			zIndex: 200
		},

		contentTypes: [],
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
	},

	

	methods:
	{
		// ----------------------------------
        //	Open dialog
        // ----------------------------------
        
		open(title, options)
		{
			// Initial settings
			this.dialog = true;
			this.title = title;
			
			if (this.$refs.form)
			{
				this.$refs.form.reset();
			}
			
			this.name = '';
			this.options = Object.assign(this.options, options);

			if (!options) this.options.color = 'primary';
			if (options && !options.color) this.options.color = 'primary';


			// Key to our project
			const key = this.$route.params.key;
			fb; key;

			// Reset types
			this.contentTypes = [];

			// Get content types from firestore
			if (key)
			{
				const collection = fb.db
					.collection('dev-collection')
					.doc('dev-doc')
					.collection(key)
					.doc(key)
					.collection('view-templates');
				
				
				collection.get()
				.then((querySnapshot) =>
				{
					querySnapshot.forEach((doc) =>
					{
						const docData = doc.data();
						docData.id = doc.id;
						this.contentTypes.push( { name: docData.name, id: doc.id, data:docData } );
					});
				})
				.catch((error) =>
				{
					console.log('Error getting user document:', error.message);
				});
			}





			// Create promise
			return new Promise((resolve, reject) =>
			{
				this.resolve = resolve;
				this.reject = reject;
			})
		},

		agree()
		{
			if (this.$refs.form.validate() && this.contentType !== null)
			{
				this.resolve( { createdName: this.name, docData: agile.getObjectById(this.contentTypes, this.contentType) } );
				this.dialog = false;
			}
		},

		cancel()
		{
			this.resolve(false);
			this.dialog = false;
		}
	}
}
</script>